<template>
  <v-snackbar
    v-model="showSnackbar"
    :color="snackbarContent.color"
    :multi-line="true"
    :top="true"
    :absolute="true"
    elevation="0"
    id="notification"
  >
    <v-row class="ma-0 pa-0" align="center">
      <div class="mr-2">
        <v-img
          v-if="snackbarContent.assetIcon"
          :src="snackbarContent.assetIcon"
          width="25"
          height="25"
        ></v-img>
        <v-icon v-else-if="snackbarContent.icon">{{
          snackbarContent.icon
        }}</v-icon>
      </div>

      <span v-html="snackbarContent.message"></span>
    </v-row>
    <template v-slot:action="{ attrs }">
      <v-btn icon dark text v-bind="attrs" @click="hideSnackbar()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      showSnackbar: false,
    }
  },
  computed: {
    ...mapGetters(['snackbarVisible', 'snackbarContent']),
  },
  methods: {
    ...mapActions(['hideSnackbar']),
  },
  watch: {
    snackbarVisible(newValue) {
      this.showSnackbar = newValue
    },
    showSnackbar(newValue) {
      if (!newValue) {
        // this.hideSnackbar()
      }
    },
  },
}
</script>

<style lang="sass">
#notification > .v-snack__wrapper
  max-width: none
  width: 100%
  margin: 8px 20px
</style>
